import React from 'react'

import injectStyles from 'react-jss'
import styles from './styles'

const ChatImagePreview = ({ fileURL, classes }) => {
  return (
    <a
      href={fileURL}
      target="_blank"
      className={classes.wrapper}
      rel="noreferrer"
    >
      <img className={classes.image} src={fileURL} alt="" />
    </a>
  )
}

export default injectStyles(styles)(ChatImagePreview)
